// A simple utility function to reload the page, which can be mocked easily in tests. This is useful for cases where we want to force a full page reload, such as after a user logs out or when we want to reset the application state completely.
export const reloadPage = () => window.location.reload();
